// extracted by mini-css-extract-plugin
module.exports = {"FakeArrowLink":"styles_FakeArrowLink__1M-wS","arrow":"styles_arrow__3BDuA"};